/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleGradeOverrideRequestLastKnownEtag } from './moduleGradeOverrideRequestLastKnownEtag';

/**
 * Admin request to set or overwrite a module grade with a required comment.
 */
export interface ModuleGradeOverrideRequest {
  grade: number;
  comment: string;
  /** Optional ETag from the last read of the module submission document. */
  lastKnownEtag?: ModuleGradeOverrideRequestLastKnownEtag;
}
